












































































































































































































import {Component, Mixins, Watch} from "vue-property-decorator";
import {mapGetters, mapState} from "vuex";
import IAskuePointsByObject from "@/models/consumption-table/AskuePointsByObject.interface";
import AppApiMixin from "@/components/mixins/AppApi.vue";
import AskueConsumptionTable from "@/components/for-turnovers-and-reports-view/AskueConsumptionTable.component.vue";
import InvisibleWall from "@/components/InvisibleWall.vue";
import Page from "@/components/for-page-grid/Page.vue";
import XNotice from "@/components/hoc/SimpleNotice.vue";
import XSlider from "@/components/SimpleSlider.vue";
import DropdownWithDatePickerWithoutRange from "../hoc/DropdownWithDatePickerWithoutRange.vue";
import ConsumedBarChart from "./ConsumedBarChart.vue";
import ConsumedChartAskue from "./ConsumedChartAskue.vue";
import AskueTable from "./AskueTable.vue";
import {OrganizationConsumption} from "@/models/organization";
import IChosenAsdPointProps from "@/models/consumption-table/ChosenAsdPointProps.interface";

@Component({
  components: {
    AskueConsumptionTable,
    InvisibleWall,
    Page,
    XNotice,
    XSlider,
    DropdownWithDatePickerWithoutRange,
    ConsumedBarChart,
    ConsumedChartAskue,
    AskueTable
  },
  computed: {
    ...mapGetters({
      contractId: "contract/id",
    }),
    ...mapState({asd: "asd"}),
    ...mapGetters("asd", {
      sortedPointsByObject: "sortedPointsByObject",
    }),
  },
})
class AskueTabContent extends Mixins(AppApiMixin) {
  [x: string]: any;

  showLoader = false;
  showSlider = false;

  dates: string[] = [];
  consumptionList: OrganizationConsumption[] = [];
  tableConsumptionList = [];
  tableHeaders = [];
  tableChannelsIds = [];

  channelInfo = [];

  selectedDate = null;

  // состояния кнопок меню
  viewMode = "grid";

  // тип отчета
  reportType = "month";
  reportDates: string[] = [];
  diffToggle: boolean = true;

  // каналы
  channelToggle: {};
  channelColors: string[] = [
    '#D17373',
    '#A1887F',
    '#8B9684',
    '#9575CD',
    '#7986CB',
    '#455A64',
    '#AED581',
    '#81C784',
    '#4DB6AC',
    '#FFB74D',
    '#64B5F6',
    '#4DD0E1',
  ];

  chosenPointProps: IChosenAsdPointProps = {
    id: 0,
    asdId: 0,
    level: 0,
    mode: 0,
    name: "",
    puName: "",
    puNumber: "",
    tuName: ""
  };

  data() {
    return {
      channelToggle: this.channelToggle,
    };
  }

  @Watch("showSlider")
  public showSliderChanged() {
    if (this.showSlider) {
      this.updateReportType();
    }
  }

  public updateChosenPoint(data) {
    this.chosenPointProps = data;
    this.updateChannels();
    this.updateTable();
  }

  public onChannelCheckboxClick(id, value) {
    this.updateChart();
  }

  public updateChannels() {
    // исключаем пустые запросы
    if (this.chosenPointProps.asdId <= 0) {
      this.showLoader = false;
      return;
    }

    const {contractId, reportType} = this
    const channelsPayload = {
      contractId,
      asdId: this.chosenPointProps.asdId,
      reportType,
      date: this.selectedDate,
    }
    this.getChannels(channelsPayload, (channelsList: []) => {
      this.channelToggle = channelsList['initialization'];
      this.channelInfo = channelsList['channels'];
      this.updateChart();
    }).finally(() => {
      this.showLoader = false;
    });
  }

  public updateReportType() {
    this.viewMode = "grid";
  }

  public get protectedSortedAskueByObject(): IAskuePointsByObject[] {
    return this.sortedPointsByObject || [];
  }

  public updateAllElements() {
    this.updateChart();
    this.updateTable();
  }

  public updateDate(data) {
    this.selectedDate = data;
    this.updateAllElements();
  }

  public updateTable() {
    // исключаем пустые запросы
    if (this.chosenPointProps.asdId <= 0) {
      this.showLoader = false;
      return;
    }

    const {
      contractId,
      channelToggle,
      reportType,
      diffToggle,
    } = this;
    const payload = {
      contractId,
      asdId: this.chosenPointProps.asdId,
      channelToggle,
      reportType,
      diffToggle,
      selectedDate: this.selectedDate,
    };
    this.getTableAnalysis(
      payload,
      (consumptionList: {}) => {
        this.tableConsumptionList = consumptionList['channels']['data'];
        this.tableHeaders = consumptionList['channels']['names'];
        this.tableChannelsIds = consumptionList['channels']['ids']
      }
    ).finally(() => {
      this.showLoader = false;
    });
  }

  public mounted() {
    this.getContractPoints(this.contractId);
    this.updateChannels();
    this.updateTable();
  }

  public updateChart() {
    // исключаем пустые запросы
    if (this.chosenPointProps.asdId <= 0) {
      this.showLoader = false;
      return;
    }

    const {
      contractId,
      // dates,
      channelToggle,
      reportType,
      diffToggle,
    } = this;
    // const [from, to] = dates;
    const payload = {
      contractId,
      asdId: this.chosenPointProps.asdId,
      channelToggle,
      reportType,
      diffToggle,
      selectedDate: this.selectedDate,
    };

    this.getChannelsList(
      payload,
      (consumptionList: {}) => {
        this.consumptionList = consumptionList['channels']['data'];
      }
    ).finally(() => {
      this.showLoader = false;
    });
  }
}

export default AskueTabContent;
